import { useApi } from "@lending/lib/api";

interface Props {
  onSuccess?: () => Promise<void>;
  onError?: (error: unknown) => void;
}

function useCreateCreditCardOfferSelectionQuery({ onSuccess, onError }: Props = {}) {
  const $api = useApi();

  return $api.useMutation("post", "/v2/lending/credit_card_offer_selections/", {
    onSuccess,
    onError,
  });
}

export { useCreateCreditCardOfferSelectionQuery };
